export default __webpack_public_path__ + "static/media/hellstrikes5.d16ad2c8.png";